import React from "react";

const services = [
  {
    title: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the...",
    icon: (
      <svg className="w-10 h-10 text-secondary" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124l-.825-9.4A1.125 1.125 0 0 0 18.45 7.5H15V6.75A2.25 2.25 0 0 0 12.75 4.5H8.25a2.25 2.25 0 0 0-2.25 2.25v7.5m10.5-6h2.25M9 10.5h3" />
      </svg>
    )
  },
  {
    title: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the...",
    icon: (
      <svg className="w-10 h-10 text-secondary" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
      </svg>
    )
  },
  {
    title: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the...",
    icon: (
      <svg className="w-10 h-10 text-secondary" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.905 0-5.64-.78-8.006-2.141m16.012 0a9 9 0 0 1 0 5.482m-16 0a9 9 0 0 1 0-5.482m16 0A11.953 11.953 0 0 1 12 15c-2.905 0-5.64.78-8.006 2.141m0 0A9 9 0 0 0 12 21" />
      </svg>
    )
  },
  {
    title: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the...",
    icon: (
      <svg className="w-10 h-10 text-secondary" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m0 0a8.91 8.91 0 0 1-.374-1.896 3 3 0 0 0-5.626-1.53c.024.364.06.723.107 1.077M9 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm12.75 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0z" />
      </svg>
    )
  }
];

export default function ServicesMystio() {
  return (
    <section className="w-full py-20 px-6 bg-black text-white">
      <div className="max-w-6xl mx-auto">
        {/* Title */}
        <h2 className="text-3xl sm:text-4xl font-bold font-oswald tracking-wider mb-12 text-left uppercase">
          Our Services
        </h2>

        {/* Grid Container */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-8 rounded-xl border border-neutral-800 bg-neutral-950/40 hover:border-secondary hover:shadow-[0_0_15px_rgba(255,140,33,0.15)] transition-all duration-350 select-none group"
            >
              {/* Icon */}
              <div className="mb-6 transform group-hover:scale-110 transition-transform duration-300">
                {service.icon}
              </div>

              {/* Title */}
              <h3 className="text-lg font-bold font-oswald text-secondary tracking-wide uppercase mb-3">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-neutral-400 font-outfit text-sm leading-relaxed mb-6 flex-grow">
                {service.description}
              </p>

              {/* Link */}
              <a
                href="#learn-more"
                onClick={(e) => e.preventDefault()}
                className="text-xs text-white font-medium uppercase tracking-wider underline hover:text-secondary transition-colors"
              >
                LEARN MORE
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
